import { AppProviders } from '@dofleini/security';
import PropTypes from 'prop-types';
import React, { memo } from 'react';

import { SessionControlProvider } from '@/contexts/SessionControlContext';
import { useMe } from '@/modules/authentication/hooks/useUsers';
import * as AuthClient from '@/modules/authentication/services/AuthClient';

const SecurityProvider = ({ children }) => {
  const { data, isLoading, refetch, isStale } = useMe();
  
  return (
    <AppProviders
      user={data}
      isLoading={!data && isLoading}
      authClient={AuthClient}
      reload={refetch}
      isSettled={isStale}
      disableReloadOnError
    >
      <SessionControlProvider>
        {children}
      </SessionControlProvider>
    </AppProviders>
  );
};

export default memo(SecurityProvider);

SecurityProvider.propTypes = {
  children: PropTypes.any
};
